import { render, staticRenderFns } from "./AuditActionlist.vue?vue&type=template&id=5143fb22&"
import script from "./AuditActionlist.vue?vue&type=script&lang=js&"
export * from "./AuditActionlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports